import { render, staticRenderFns } from "./sceneryMore.vue?vue&type=template&id=ff786dba&scoped=true"
import script from "./sceneryMore.vue?vue&type=script&lang=js"
export * from "./sceneryMore.vue?vue&type=script&lang=js"
import style0 from "./sceneryMore.vue?vue&type=style&index=0&id=ff786dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff786dba",
  null
  
)

export default component.exports